import { AxiosError } from 'axios';
import { SagaIterator } from 'redux-saga';
import { all, call, fork, put, spawn } from 'redux-saga/effects';

import catalogueSaga from './catalogue/catalogue.saga.ts';
import { toastReducer } from './reducers/toast.reducer.ts';
import auditLogSaga from './sagas/auditLog.saga.ts';
import emailSubscriptionSaga from './sagas/emailSubscription.saga.ts';
import featureFlagsSaga from './sagas/featureFlags.saga.ts';
import invitationSaga from './sagas/invitation.saga.ts';
import notificationsSaga from './sagas/notifications.saga.ts';
import projectsSaga from './sagas/projects.saga.ts';
import subscriptionSaga from './sagas/subscription.saga.ts';
import toastSaga from './sagas/toast.saga.ts';
import userSaga from './sagas/user.saga.ts';
import webSocketSaga from './sagas/webSocket.saga.ts';
import workspaceSaga from './sagas/workspace.saga.ts';

const { showToast } = toastReducer.actions;

// Wrap each saga with error handling
function* watchSaga(saga: () => SagaIterator) {
  while (true) {
    try {
      yield call(saga);
      break; // Exit only if saga completes normally
    } catch (error) {
      console.error('Error from saga', error);

      let errorMsg = 'Unknown error';

      if ((error as AxiosError)?.response?.data) {
        errorMsg = (error as AxiosError).response?.data as string;
      } else if (error instanceof Error) {
        errorMsg = error.message;
      }

      yield put(
        showToast({
          message: errorMsg || 'common.toast.unknownError',
          type: 'error',
        }),
      );
    }
  }
}

export default function* rootSaga() {
  const sagas = [
    userSaga,
    projectsSaga,
    catalogueSaga,
    workspaceSaga,
    webSocketSaga,
    invitationSaga,
    featureFlagsSaga,
    notificationsSaga,
    subscriptionSaga,
    emailSubscriptionSaga,
    auditLogSaga,
  ];

  // Load all sagas in parallel with individual error handling
  yield all(sagas.map((saga) => fork(watchSaga, saga)));

  // Toast saga is spawned separately as it likely doesn't need to be restarted
  yield spawn(toastSaga);
}
